{
  "srTitle": "Anti Human Safari Project — protección frente a drones para civiles en Jersón, Ucrania",
  "logoAlt": "Logotipo del proyecto Anti Human Safari",
  "intro": "Proporcionamos equipos de protección contra ataques de pequeños drones a voluntarios, servicios de emergencia y trabajadores de infraestructuras críticas en Jersón, Ucrania.",
  "safari": "Desde el verano de 2024, los civiles de Jersón son perseguidos sistemáticamente por el ejército ruso con drones de vídeo, en una campaña de terror conocida como «Human Safari».",
  "unLink": "La Comisión de la ONU reconoce el Human Safari como crimen de guerra",
  "donateNow": "Donar ahora",
  "donateMonthly": "Donar mensualmente",
  "otherWays": "otras formas de donar",
  "instagram": "Instagram",
  "pastFundraisers": "Recaudaciones anteriores:",
  "fundraiser2025": "Recaudación 2025",
  "donateVia": "Donar mediante:",
  "charityRef": "a través de una organización benéfica del Reino Unido, con la referencia:",
  "germanCharityRef": "a través de una organización benéfica alemana, con la referencia:",
  "copy": "Copiar",
  "copied": "¡Copiado!",
  "close": "Cerrar",
  "viewMedia": "Ver el contenido",
  "andrushenkoCredit": "Oleksandr Andrushenko, fotocorresponsal del medio Vgoru",
  "fruitSellerDescription": "Un vendedor de fruta perseguido por un dron de fibra óptica",
  "khersonPoliceCredit": "de @khersonpolice",
  "firefighterDescription": "Un bombero apaga un coche tras un ataque del «Human Safari»; detrás yace una víctima",
  "previousMedia": "Anterior",
  "nextMedia": "Siguiente",
  "fpvDroneDescription": "Dron FPV de caza durante el «Human Safari»",
  "busAttackDescription": "Uno de los muchos ataques con drones FPV contra el transporte público",
  "notFoundTitle": "Página no encontrada",
  "notFoundMessage": "Esa página no existe. Puede que se haya movido o que el enlace sea incorrecto.",
  "backHome": "Volver al inicio",
  "droneDetectorDescription": "Los detectores de drones son pequeños dispositivos portátiles que avisan cuando hay un dron cerca",
  "vestDescription": "Los chalecos protectores ligeros pueden reducir la gravedad de las heridas causadas por un ataque con dron"
}
